import React from "react";
import './student-answered-status-board.scss';
import { CountdownCircleTimer } from 'react-countdown-circle-timer'
import { getImageSource } from "../../../utility/image-source";
import { ImageConstants } from "../../../constants/constants";




class StudentAnsweredStatusBoard extends React.Component {


    state = {
        // studentsList: [
        //     { studentNumber: 1, receivedAnswer: true },
        //     { studentNumber: 2, receivedAnswer: true },
        //     { studentNumber: 3, receivedAnswer: true },
        //     { studentNumber: 4, receivedAnswer: true },
        //     { studentNumber: 5, receivedAnswer: true },
        //     { studentNumber: 6, receivedAnswer: true },
        //     { studentNumber: 7, receivedAnswer: true },
        //     { studentNumber: 8, receivedAnswer: true },
        //     { studentNumber: 9, receivedAnswer: false },
        //     { studentNumber: 10, receivedAnswer: false }
        // ]
        studentsList: this.props.studentList,
        hoveredStudent: null

    }






    children = ({ remainingTime }) => {
        const minutes = Math.floor(remainingTime / 60)
        const seconds = remainingTime % 60

        return `${minutes}:${seconds}`
    }


    addExtraSeconds() {
        this.props.delegate && this.props.delegate.startExtraCountDown && this.props.delegate.startExtraCountDown()
    }

    renderSmallStatusBar() {
        return (
            <div className="student-answered-status-board">
                <div className='timer-wrapper'>
                    <div className=''>
                        <CountdownCircleTimer
                            size={100}
                            trailColor='#1CEA24'
                            isPlaying={this.props.isPlaying}
                            duration={this.props.questionTime}
                            colors={["#004777", "#F7B801", "#A30000", "#A30000"]}
                            colorsTime={[10, 6, 3, 0]}
                            onComplete={() => ({ shouldRepeat: false, delay: 1 }, this.addExtraSeconds())}
                        >
                            {(remainingTime) => (
                                <div className="d-flex flex-column justify-content-center align-items-center">
                                    <div className="timer-text">
                                        {this.children(remainingTime)}
                                    </div>
                                    {
                                        !this.props.isPlaying ?
                                            <div className="">
                                                <img className="pause-button-image-size" src={getImageSource(ImageConstants.PAUSE_BUTTON)} />
                                            </div>
                                            :
                                            <></>
                                    }

                                </div>
                            )}

                        </CountdownCircleTimer>
                    </div>
                </div>
                <div className="d-flex justify-content-center align-items-center button-wrapper mt-4">
                    {
                        this.state.studentsList && this.state.studentsList.length ?
                            this.state.studentsList.map(student => (
                                student.isTeacher ? <></> :
                                    <div className={`student-roll-number-button ml-1 mb-1 ${student.receivedAnswer ? 'enable-button' : ''}`}>{student.studentNumber}</div>
                            ))
                            :
                            <>No Students Found</>
                    }
                </div>
            </div>
        )
    }

    handleMouseEnter = (studentNumber) => {
        this.setState({ hoveredStudent: studentNumber });
    };

    handleMouseLeave = () => {
        this.setState({ hoveredStudent: null });
    };

    renderLargeStatusBar() {
        return (
            <div className="large-student-answered-status-board">
                <div className='timer-wrapper'>
                    <div className=''>
                        <CountdownCircleTimer
                            size={10}
                            trailColor='#FFFFFF'
                            isPlaying={this.props.isPlaying}
                            duration={this.props.questionTime}
                            colors={["#FFFFFF", "#FFFFFF", "#FFFFFF", "#FFFFFF"]}
                            colorsTime={[10, 6, 3, 0]}
                            onComplete={() => ({ shouldRepeat: false, delay: 1 }, this.addExtraSeconds())}
                        >
                            {(remainingTime) => (
                                <div className="d-flex flex-column justify-content-center align-items-center">
                                    <div className="timer-text">
                                        {this.children(remainingTime)}
                                    </div>
                                    {
                                        !this.props.isPlaying ?
                                            <div className="">
                                                <img className="pause-button-image-size" src={getImageSource(ImageConstants.PAUSE_BUTTON)} />
                                            </div>
                                            :
                                            <></>
                                    }

                                </div>
                            )}

                        </CountdownCircleTimer>
                    </div>
                </div>
                <div className="d-flex justify-content-center align-items-center button-wrapper mt-4">
                    {
                        this.state.studentsList && this.state.studentsList.length ?
                            this.state.studentsList.map(student => (
                                student.isTeacher ? <></> :
                                    <div className="position-relative" onMouseEnter={() => this.handleMouseEnter(student.studentNumber)}
                                        onMouseLeave={this.handleMouseLeave}>
                                        <div
                                            className={`student-roll-number-button ml-1 mb-1 ${student.receivedAnswer ? 'enable-button' : ''}`}>{student.studentNumber}</div>
                                        {this.state.hoveredStudent === student.studentNumber && (
                                            <div
                                                style={{
                                                    position: "absolute",
                                                    bottom: "-50px", // Align at the bottom
                                                    left: "50%",
                                                    transform: "translateX(-50%)",
                                                    fontSize: "28px",
                                                    color: "blue",
                                                    zIndex: '999999'
                                                }}
                                                className="student-name"
                                            >
                                                {student.userName}
                                            </div>
                                        )}
                                    </div>

                            ))
                            :
                            <>No Students Found</>
                    }
                </div>
            </div>
        )
    }


    render() {

        console.log(this.props.showLargeStudentResponseSideBar)



        return (
            <div>
                {
                    this.props.isFFF || this.props.showLargeStudentResponseSideBar ?

                        this.renderLargeStatusBar()
                        :
                        this.renderSmallStatusBar()

                }
            </div>
        )



    }

}

export default StudentAnsweredStatusBoard;